module.exports = __webpack_public_path__ + "img/fruit-citrus-350x184.4b5c6d06.jpg";